module.exports = require("core-js-pure/features/instance/reverse");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/reverse.js
// module id = 480
// module chunks = 13